import React from 'react';
import { BookOpenIcon, GiftIcon, GlobeIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
const includes = [{
  icon: BookOpenIcon,
  title: '5-MIN MENOPAUSE™',
  detail: '6 Premium Guides',
  value: '$97 Value'
}, {
  icon: GiftIcon,
  title: '5 Exclusive Bonuses',
  detail: 'Cases, quick reference, scripts, error check, checklists',
  value: '$197 Value'
}];
const perks = ['One-time payment', 'Lifetime access', 'No monthly fees', 'Instant digital access'];
export function Offer() {
  return <section id="offer" className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" aria-labelledby="offer-title" data-id="element-249" data-mp="3nvshgjot4pf6">
      <div className="mx-auto max-w-3xl" data-id="element-250" data-mp="3sttyz06l4goj">
        <div id="offer-title" data-id="element-251" data-mp="1p409fu4s35m">
          <SectionHeading eyebrow="Special launch offer" title="Here’s everything you’ll receive today" data-id="element-252" data-mp="1qezd2cmsmqe" />
        </div>

        <div className="mt-9 overflow-hidden rounded-3xl border border-navy/10 bg-white shadow-lift" data-id="element-253" data-mp="1fmn7eqbpmjj6">
          <ul className="divide-y divide-navy/10" data-id="element-254" data-mp="1bkidrrl9hmwj">
            {includes.map(item => <li key={item.title} className="flex items-start gap-4 p-5 sm:p-6" data-id="element-255" data-mp="16lys7sakyd4p">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-rose-mist text-rose" aria-hidden="true" data-id="element-256" data-mp="16o1tx9l3hup9">
                  <item.icon className="h-5 w-5" data-id="element-257" data-mp="1zch2pedmvgs5" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-258" data-mp="1ui34l47l6vjs">
                  <p className="font-display text-[18px] font-bold leading-tight text-navy sm:text-xl" data-id="element-259" data-mp="1pkt66z27z9jt">
                    {item.title}
                  </p>
                  <p className="mt-1 text-[13.5px] leading-snug text-navy/65" data-id="element-260" data-mp="2n19ucyn832gy">{item.detail}</p>
                </div>
                <span className="shrink-0 text-right text-[13px] font-bold text-navy/45 line-through" data-id="element-261" data-mp="2i7dxy0mlxnnw">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="flex items-center justify-between gap-4 border-t border-navy/10 bg-sand px-5 py-4 sm:px-6" data-id="element-262" data-mp="366elieypo5ty">
            <span className="text-[12px] font-extrabold uppercase tracking-[0.12em] text-navy/70" data-id="element-263" data-mp="2weio764g8jqs">
              Total value
            </span>
            <span className="font-display text-2xl font-bold text-navy/45 line-through" data-id="element-264" data-mp="2idel4mlevng3">$294</span>
          </div>

          <div className="bg-navy px-5 py-8 text-center sm:px-8 sm:py-10" data-id="element-265" data-mp="2nfdqu34miwg7">
            <p className="text-[14px] leading-relaxed text-white/70" data-id="element-266" data-mp="29fmf691kxs5d">
              But today you won’t pay $294. Not $197. Not even $97.
            </p>
            <p className="mt-5 text-[11.5px] font-extrabold uppercase tracking-[0.14em] text-rose-light" data-id="element-267" data-mp="7my79mdzqgj9">
              Get complete access today for only
            </p>
            <p className="mt-2 font-display text-[72px] font-bold leading-none text-white sm:text-[88px]" data-id="element-268" data-mp="bmfg8psmlvt6">
              $27
            </p>

            <ul className="mx-auto mt-6 grid max-w-sm grid-cols-2 gap-2" data-id="element-269" data-mp="1s5iid843cnta">
              {perks.map(perk => <li key={perk} className="flex items-center gap-1.5 rounded-xl bg-white/10 px-3 py-2.5 text-left text-[12.5px] font-semibold text-white" data-id="element-270" data-mp="25wnfa2g2r1zx">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-271" data-mp="2fti5zz63vy3n" />
                  {perk}
                </li>)}
            </ul>

            <p className="mx-auto mt-6 max-w-md text-[13.5px] leading-relaxed text-white/65" data-id="element-272" data-mp="2ovhs35vz9sdg">
              For less than the cost of a typical dinner, you’ll have a structured menopause
              consultation system you can return to whenever you need it.
            </p>

            <div className="mt-7" data-id="element-273" data-mp="pido70kg6z5e">
              <CtaButton label="Yes, I want 5-MIN MENOPAUSE™" data-id="element-274" data-mp="pjfak16wz82f" />
              <p className="mt-3 text-center text-[12.5px] font-medium text-white/65" data-id="element-275" data-mp="rx2a2es7xxig">
                One-time payment of $27 · Instant access · Lifetime access · 7-day guarantee
              </p>
            </div>

            <p className="mt-4 flex items-start justify-center gap-1.5 text-center text-[12.5px] font-medium text-white/65" data-id="element-276" data-mp="10x7a23v31tml">
              <GlobeIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-teal" aria-hidden="true" data-id="element-277" data-mp="15w1oktm0ow0w" />
              Currency conversion is automatic — you pay in your local currency at checkout where
              supported.
            </p>

            <div className="mt-8" data-id="element-278" data-mp="d5jm9ut4ayoj">
              <CountdownTimer tone="dark" data-id="element-279" data-mp="i6pgxy6c8w0p" />
            </div>

            <div className="mt-6" data-id="element-280" data-mp="i560a6grsiye">
              <ScarcityBar tone="dark" data-id="element-281" data-mp="mxz4mt8btp9y" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}